import HttpClient from './httpClient';

function logout() {
  return new HttpClient.Builder().post('/accnt/logout').execute();
}

export default logout;
